import { createContext } from 'react';
import { GainsightService } from './types';

const mockGainsightService: GainsightService = {
    initialize: async () => Promise.resolve(),
    setUser: () => {},
    setGlobalContext: () => {},
    trackPageView: () => {},
    trackEvent: () => {},
    reset: () => {},
    closeKnowledgeCenter: () => {},
};

export const GainsightContext = createContext<GainsightService>(mockGainsightService);

interface GainsightServiceProviderProps {
    /**
     * Instance of gainsightService to be aproachable in components
     */
    gainsightService: GainsightService;
}

export const GainsightServiceProvider: React.FC<React.PropsWithChildren<GainsightServiceProviderProps>> = ({
    children,
    gainsightService,
}) => <GainsightContext.Provider value={gainsightService}>{children}</GainsightContext.Provider>;
